<template>
  <div class="access-level-group">
    <label
      v-for="option in filteredOptions"
      :key="option.value"
      class="access-pill"
      :class="[
        option.value.toLowerCase(),
        { active: resolvedValue === option.value }
      ]"
      @click="toggle(option.value)"
    >
      {{ option.label }}
    </label>
  </div>
</template>


<script>
export default {
  name: "AccessLevelSelect",

  props: {
    modelValue: {
      type: String,
      default: "N"
    },
    userType: {
      type: String, // staff | manager | admin
      default: null
    },
    id: {
      type: [String, Number],
      required: true
    }
  },

  emits: ["update:modelValue"],

  computed: {
    // Always fallback to None internally
    resolvedValue() {
      return this.modelValue || "N";
    },

    filteredOptions() {
      const allOptions = [
        { value: "R", label: "Read" },
        { value: "RW", label: "Read / Write" },
        { value: "RE", label: "Read / Edit" },
        { value: "RWE", label: "Read / Write / Edit" }
      ];

      // STAFF → LIMITED
      if (this.userType === "staff") {
        return allOptions.filter(opt =>
          ["R", "RW", "RE"].includes(opt.value)
        );
      }

      return allOptions;
    }
  },

  methods: {
    toggle(value) {
      // If clicking same value → deselect (None)
      if (this.resolvedValue === value) {
        this.$emit("update:modelValue", "N");
      } else {
        this.$emit("update:modelValue", value);
      }
    }
  }
};
</script>

<style scoped>
.access-level-group {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.access-pill {
  cursor: pointer;
  padding: 6px 12px;
  font-size: 0.85rem;
  border-radius: 999px;
  border: 1px solid #d0d5dd;
  background: #f9fafb;
  color: #344054;
  user-select: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.access-pill:hover {
  background: #f1f5f9;
}

.access-pill.active {
  color: #fff;
  border-color: transparent;
  font-weight: 600;
}

/* Colors */
.access-pill.n.active {
  background: #6c757d; /* neutral gray */
}
/* Read */
.access-pill.r.active {
  background: #198754; /* green */
}

/* Read / Write */
.access-pill.rw.active {
  background: #0d6efd; /* blue */
}

/* Read / Edit */
.access-pill.re.active {
  background: #0dcaf0; /* sky blue */
}

/* Read / Write / Edit */
.access-pill.rwe.active {
  background: #fd7e14; /* orange */
}
</style>

